import { createStore } from 'vuex'

// Import modules
import auth from './modules/auth'
import customers from './modules/customers'
import properties from './modules/properties'
import transactions from './modules/transactions'
import settings from './modules/settings'

export default createStore({
  modules: {
    auth,
    customers,
    properties,
    transactions,
    settings
  },

  state: {
    loading: false,
    notification: null
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },

    SET_NOTIFICATION(state, notification) {
      state.notification = notification
    },

    CLEAR_NOTIFICATION(state) {
      state.notification = null
    }
  },

  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },

    showNotification({ commit }, notification) {
      commit('SET_NOTIFICATION', notification)
    },

    clearNotification({ commit }) {
      commit('CLEAR_NOTIFICATION')
    }
  },

  getters: {
    isLoading: state => state.loading,
    notification: state => state.notification
  }
})